module.exports = __webpack_public_path__ + "img/equipment-cap-01.00b27451.png";